"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.csv2json = function (str) {
    var delimiter = ",";
    return str.split("\n").reduce(function (table, row) {
        if (!table)
            return;
        table.push(row.split(delimiter).map(function (d) {
            return d.trim();
        }));
        return table;
    }, []);
};
